import { Badge, Box, Tooltip, Typography } from "@mui/material";
import { LinearProgress } from "react-admin";
import IconInACircle from "../../../misc/IconInACircle";

export function TrainingItem(props: {
  icon: JSX.Element;
  label: string;
  value?: number | string;
  outOf?: number | undefined;
  unit?: string;
  trailing?: React.ReactNode;
  muted?: boolean;
  plannedLessonUnits?: number;
  loadingLabel?: string;
}) {
  const { icon, label, value, outOf, unit, trailing, muted, plannedLessonUnits, loadingLabel } = props;

  const formatValue = (val: number | string) => {
    if (typeof val === "number") {
      return val.toLocaleString("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    }
    return val;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        "@media (max-width: 414px)": {
          "& > .MuiIconButton-root": { width: "28px", height: "28px", padding: 0 },
        },
      }}
    >
      <Badge
        badgeContent={
          plannedLessonUnits && (
            <Tooltip title="geplante UE" placement="right-start">
              <span>{Math.floor(plannedLessonUnits)}</span>
            </Tooltip>
          )
        }
        color="warning"
        invisible={!plannedLessonUnits || plannedLessonUnits < 1}
        sx={{
          "& .MuiBadge-badge": {
            cursor: "default",
            marginTop: "3px",
            right: "2px",
            fontSize: 11,
            fontWeight: "bold",
            minWidth: 18,
            height: 18,
          },
        }}
      >
        <IconInACircle
          icon={icon}
          variant={muted ? "muted" : "default"}
          sx={{
            height: 32,
            width: 32,
            "& > svg": { width: 20, height: 20 },
            "@media (max-width: 414px)": {
              height: 28,
              width: 28,
              "& > svg": { width: 18, height: 18 },
            },
          }}
        />
      </Badge>
      <Box sx={{ ml: "12px", minWidth: 0, "@media (max-width: 414px)": { ml: "8px" } }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
          {typeof value === "undefined" && (
            <LinearProgress timeout={0} aria-label={loadingLabel} sx={{ width: "1.5em" }} />
          )}
          {typeof value !== "undefined" && (
            <>
              <Typography sx={{ fontWeight: "bold", fontSize: 17 }}>{formatValue(value)}</Typography>
              {outOf && <Typography sx={{ fontSize: 14, whiteSpace: "nowrap" }}>/ {outOf}</Typography>}
              {unit && <Typography sx={{ fontSize: 14 }}>{unit}</Typography>}
            </>
          )}
        </Box>
        <Typography sx={{ color: "text.secondary", fontSize: 12, marginTop: -0.5 }}>{label}</Typography>
      </Box>
      {trailing}
    </Box>
  );
}
